import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  PrivacyPolicy,
  Footer,
} from '../../components';
import config from '../../config';

import css from './CGUPage.module.css';

const CGUPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CGUPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
    
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CGUPage" />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
        <div className={css.contentWrapper}>

          <p className={css.title}>Conditions générales d'utilisation du service ollo</p>


          <p className={css.justify}>
          Merci d'utiliser ollo ! Voici le détail des conditions d'utilisation.             
            </p>
            <p className={css.justifyNoMargin}>
            Pour toute question relative à ce sujet, n'hésitez pas à nous écrire : contact@ollo.fr          
             </p>


             <p className={css.subTitle}>
             1. Champ d’application et définitions

            </p>


            <p className={css.justify}>
            Les présentes Conditions Générales d’Utilisation s’appliquent aux services proposés par l’application et le site Internet ollo (www.ollo.fr). Le service de stationnement proposé est édité par la société ollo SAS, au capital de 1000 euros, enregistrée au Registre du Commerce et des Sociétés de Valence sous le numéro 851 386 151, et dont le siège social est situé au 9 CRS MANUEL DE FALLA 26000 VALENCE (ci-après « ollo »).

            </p>

         <p className={css.justifyNoMargin}>
         Dans les présentes Conditions Générales d’Utilisation, il est convenu que l’ensemble des termes commençant par une lettre capitale et listés ci-dessous sont définis de la manière suivante :

             </p>

             <ul>
               <li>
               • « Accès » : désigne les données et signaux permettant l'ouverture d'un Emplacement de Parking, afin qu'un Utilisateur puisse y stationner;
               </li>

               <li>
               • « Annonce » : désigne une annonce mettant à disposition un emplacement de Parking publié sur la Plateforme par un Détenteur de place ;
               </li>
               <li>
               • « Application » : désigne le logiciel applicatif ollo développé pour être accessible sur smartphones ;
               </li>
               <li>
               • « CGU » : désigne les présentes Conditions Générales d’Utilisations ;
               </li>
               <li>
               • « Compte » : désigne la création d’un compte sur la Plateforme par l’Utilisateur tel que décrit à l’article 4.1;
               </li>
               <li>
               • « Conducteur » : désigne tout Utilisateur d'un véhicule terrestre à moteur, préalablement inscrit et souhaitant réserver un emplacement de Parking sur la Plateforme ;
               </li>
               <li>
               • « Commission ollo» : désigne la Commission de ollo afférente à la Réservation d'un Parking tels que définis à l'article 8.4 ;
               </li>
               <li>
               • « Détenteur de place » : désigne tout Utilisateur, propriétaire ou locataire habilité à sous-louer un emplacement de Parking ayant enregistré son bien sur la Plateforme et ayant renseigné les principales caractéristiques de celle-ci en vue de le louer ;
               </li>
               <li>
               • « Durée Totale de la Réservation »: désigne la durée totale de la Réservation, du début de la Réservation jusqu’au moment où l’Utilisateur la termine dans l’Application incluant les éventuels Dépassements et Prolongements ;
               </li>
               <li>
               • « Evaluation » : désigne les notes et évaluations des Utilisateurs tels que définis à l'article 6.5
               </li>
               <li>
               • « Moyens d’identifications» : désigne les moyens d’identification pour accéder au Service tel que défini à l’article 4.2 ;
               </li>
               <li>
               • « Plateforme » : désigne la plateforme de réservation d’emplacement de Parkings et vise à la fois le Site Internet et l’Application ;
               </li>

               <li>
               • « Parking » ou « Emplacement de Parking » : désigne un ouvrage destiné au stationnement de véhicule mis en ligne sur la Plateforme par un Détenteur de place et auquel le Conducteur a accès dans le cadre de son utilisation du Service ollo ;
               </li>

               <li>
               • « Pénalités de retard » : désigne les modalités de pénalités décrites à l’article 8.7
               </li>

               <li>
               • « Réservation » : désigne la période pendant laquelle un Conducteur a réservé un emplacement de Parking sur la Plateforme.
               </li>

               <li>
               • « Service Client »: désigne le service d'assistance disponible à l’adresse email contact@ollo.fr ;
               </li>

               <li>
               • « Service ollo » ou « Service» : désigne l’ensemble des solutions qui permettent la mise en relation entre les Conducteurs et les Détenteurs de place, ainsi que l’Accès à l’emplacement de Parking ;
               </li>

               <li>
               • « Site Internet » : désigne le site Internet ollo accessible à l’adresse www.ollo.fr ;
               </li>

               <li>
               • « Utilisateur » : désigne toute personne physique accédant au site Internet ou à l’application mobile, regroupant à la fois les Détenteurs de place et les Conducteurs;
               </li>
               
              </ul>


              <p className={css.subTitle}>
              2. Objet

            </p>

            <p className={css.justify}>
      ollo édite une solution de mise à disposition d’emplacements de stationnement entre particuliers, permettant aux Utilisateurs de stationner en ville en toute sérénité. Exploitant la technologie ollo basée sur des innovations technologiques, ollo construit un réseau intelligent de Parkings partagés dont l’accès et le paiement sont encadrés par ollo, sans intervention sur le système existant.

Il est bien précisé que ollo n’est ni le propriétaire, ni le gestionnaire des Parkings référencés au sein de la Plateforme ollo.

ollo n’intervient pas dans les relations contractuelles entre les Conducteurs et les Détenteurs de place mais se limite à les mettre en relation en fonction des caractéristiques recherchées (emplacement géographique, durée, catégorie de véhicule, prix).

Pour les Réservations Récurrentes et Uniques, ollo permet aux Conducteurs de trouver un Parking adapté à leur besoin en fonction des Parkings disponibles publiés sur la Plateforme par les Détenteurs de Place.              
            </p>

            <p className={css.subTitle}>
          
3.Acceptation et respect des Conditions Générales d’Utilisation

            </p>

            <p className={css.subTitle2}>
            3.1 Acceptation des CGU

            </p>


            <p className={css.justify}>
            Préalablement à son inscription sur la Plateforme, l’Utilisateur reconnaît expressément avoir pris connaissance des présentes CGU ainsi que des différents documents auxquelles elles font référence et les avoir acceptées sans restriction ni réserve dès lorsqu’il clique sur la case « J’accepte les Conditions Générales d’Utilisation ».

Les présentes Conditions Générales s’appliquent pendant toute la durée de mise en ligne des Services de ollo.        
            </p>



            <p className={css.subTitle2}>
            3.2 Modifications des CGU

            </p>

            <p className={css.justify}>
            ollo se réserve le droit, à sa seule discrétion, de modifier la Plateforme ou de modifier les présentes CGU à tout moment et sans notification préalable. Si nous procédons à des modifications des présentes Conditions, y compris des Commissions ollo, nous publierons les CGU modifiées sur la Plateforme et nous vous adresserons une notification de la modification par e-mail. En l’absence d’une communication de votre part nous informant de votre refus des CGU modifiées dans un délai de trente (30) jours suivant la notification par email, votre accès ou utilisation de la Plateforme vaudra acceptation des CGU modifiées. Vous serez informé de votre droit de refus dans l’email de notification. Si vous n’acceptez pas les CGU modifiées, chacune des parties pourra mettre un terme au contrat avec effet immédiat, à la suite de quoi vous ne pourrez plus utiliser le Service ollo.     
            </p>


            <p className={css.subTitle}>
            4.  Utilisation du Service

            </p>


            <p className={css.subTitle2}>
            4.1 Inscription sur la Plateforme
            </p>

            <p className={css.justify}>
            L'inscription sur la Plateforme ollo est nécessaire pour pouvoir utiliser le Service. A défaut, un Utilisateur ne peut ni publier une Annonce ni réserver un Parking sans avoir, au préalable, créé un Compte.

Toute inscription sur la Plateforme par une personne mineure est strictement interdite. En accédant, utilisant ou vous inscrivant sur la Plateforme, l’Utilisateur déclare et garantit avoir plus de 18 ans.
            </p>

            <p className={css.justifyNoMargin}>
            La création du Compte peut se faire soit :
            </p>


            <ul>
               <li>
               • en remplissant l’ensemble des champs obligatoires figurant sur le formulaire d’inscription ;
               </li>

               <li>
               • en se connectant, via notre Plateforme, à votre compte Facebook (ci-après, « Compte Facebook ») ou à votre compte Google (ci-après, « Compte Google »). En utilisant cette fonctionnalité l’Utilisateur reconnaît que ollo aura accès, publiera sur la Plateforme et conservera certaines informations de votre Compte Facebook et/ou de votre Compte Google. Il est possible de supprimer à tout moment le lien entre le Compte Facebook ou le Compte Google et le Compte, dans la rubrique « Profil ».
               </li>

            </ul>

            <p className={css.justifyNoMargin}>
            Par ailleurs, les informations supplémentaires suivantes doivent être fournies lors de la création du Compte :
            </p>


            <ul>
              <li>
               • Pour l’utilisation du Service en tant que Conducteur :
               </li>
               <li>
               · La catégorie du véhicule, représenté par un pictogramme ;
               </li>
               <li>
               · La plaque d’immatriculation du véhicule ; 
               </li>
               <li>
               · Un numéro de téléphone mobile valide dont l’Utilisateur est titulaire;  
               </li>
               <li>
               · L’enregistrement d’une carte bancaire avec autorisation de prélèvement. 
               Lors de l'enregistrement du numéro de téléphone mobile, l'Utilisateur devra confirmer la validité du numéro de téléphone au moyen d'un code transmis sur ce numéro de téléphone.

Lors de l'enregistrement de la carte bancaire, ollo procèdera à une vérification de la validité des informations fournies, aucune somme ne sera débitée lors de cette phase de vérification.
               </li>

               <li>
               • Pour l’utilisation du Service en tant que Détenteur de place :
               </li>
               <li>
               · L’adresse exacte du Parking ;
               </li>
               <li>
               · Une description de l’emplacement du Parking ;
               </li>
               <li>
               · Les dimensions de son emplacement de Parking, représentées par un pictogramme;
               </li>
               <li>
               · Une ou plusieurs photographies de son Parking ;
               </li>
               <li>
               · Un numéro de téléphone mobile dont l’Utilisateur est titulaire ;
               </li>
               <li>
               · Pour le transfert d'argent par notre partenaire Stripe, un IBAN valide ainsi qu’une copie d’une pièce d’identité valide et les informations demandées à l’article 4.3.
               </li>

            </ul>

            <p className={css.justifyNoMargin}>
            Pour pouvoir réserver un Parking les Conducteurs doivent remplir les conditions cumulatives suivantes :
</p>
<ul>
              <li>
               • Etre inscrit sur la Plateforme sous sa véritable identité ;
               </li>
               <li>
               • Etre titulaire d’un moyen de paiement électronique en cours de validité ;
               </li>
               <li>
               • Etre titulaire d’une assurance de Responsabilité Civile en cours de validité ;
               </li>
               <li>
               • Le véhicule doit disposer d’une assurance en cours de validité, souscrite dans une compagnie notoire ;
               </li>
               <li>
               • Avoir fourni des informations vraies, exactes, complètes et actuelles
               </li>
            </ul>

            <p className={css.justify}>
            Pour pouvoir publier une Annonce sur la Plateforme, les Détenteurs de place doivent remplir les conditions cumulatives suivantes :
</p>
            <ul>
              <li>
               • Etre inscrit sur la Plateforme sous sa véritable identité ;
               </li>
               
               <li>
               • Avoir renseigné dans son Annonce que des informations vraies, exactes, complètes et actuelles ;
               </li>

               <li>
               • Ne proposer à la Réservation que des Parkings dont il est et demeure le propriétaire pendant toute la durée de la Réservation ou pour lequel il détient une autorisation expresse du propriétaire de les louer ;
               </li>

               <li>
               • Ne violer aucun accord conclu avec des tiers, tels que les accords de conseil syndical, les règlements de copropriété ou tout autre contrat conclu avec des tiers.
               </li>
            </ul>

            <p className={css.justify}>
            Le Détenteur de Place assure et s'engage à effectuer l'ensemble des déclarations fiscales et de revenus liés à l'utilisation du Service.

Dans l’hypothèse où l’Utilisateur fournirait des informations fausses ou non actuelles, ollo pourrait immédiatement, sans préavis ni indemnité, suspendre et/ou résilier l’accès au Service. L’Utilisateur s’engage à fournir tous les justificatifs requis à ollo, à première demande, et s’engage à mettre régulièrement à jour ses informations.

ollo se réserve la faculté d’accepter ou de refuser, sans motif et à sa seule discrétion, toute inscription sur la Plateforme et de suspendre et/ou supprimer le Compte de tout Utilisateur qui ne respecterait les présentes CGU.
</p>



<p className={css.subTitle2}>
4.2 Moyens d’identification et confidentialité

            </p>


            <p className={css.justify}>
            A l’occasion de son inscription, l’Utilisateur s’engage à garder secret le mot de passe choisi, qui, avec son identification de connexion (adresse e-mail), constitue ses « Moyens d’Identification ». Les Moyens d’Identification sont personnels, confidentiels, incessibles et intransmissibles.

L’utilisateur s’engage à conserver ses Moyens d’Identification secret et à ne pas les divulguer sous quelque forme que ce soit. En cas de perte ou de divulgation des Moyens d’Identification, l’Utilisateur s’oblige à en informer ollo sans délai. L’Utilisateur est seul responsable de l’utilisation faite de son Compte par un tiers, et ce, tant qu’il n’a pas expressément notifié ollo de l’utilisation frauduleuse ou de la divulgation de ses Moyens d’Identification.
</p>



<p className={css.subTitle2}>
4.3 Politique « Know Your Customer » (KYC)

            </p>

            <p className={css.justify}>
            Afin de procéder au virement des fonds collectés en utilisant le Service, ollo pourra procéder à une vérification d’identité conformément aux dispositions en vigueur pour lutter contre le blanchiment de capitaux et de financement du terrorisme. Le cas échéant, le Détenteur de place devra communiquer dans les plus brefs délais à ollo, une copie d’au moins deux documents parmi ceux présents dans la liste ci-dessous :
</p>

<ul>
              <li>
               • Passeport
               </li>
               <li>
               • Carte Nationale d’Identité (CNI)
               </li>
               <li>
               • Permis de conduire
               </li>
               <li>
               • Dernier avis d’imposition
               </li>
               
            </ul>

            <p className={css.justifyNoMargin}>
Tant que la procédure de vérification n’a pu aboutir, ollo se réserve le droit de suspendre provisoirement les paiements à destination du Détenteur de place.
</p>


<p className={css.subTitle2}>
4.4 Finalité du Service ollo

            </p>

            <p className={css.justify}>
            ​
Les Utilisateurs s’engagent à n’utiliser le Service et la Plateforme qu’à des fins non professionnelles

ollo se réserve la possibilité de suspendre votre compte ou de limiter les accès au Service des Utilisateurs qui utilisent la Plateforme et le Service à des fins professionnelles.

</p>




<p className={css.subTitle}>
5.  Utilisation du Service ollo

            </p>

            <p className={css.subTitle2}>
            5.1 Publication des Annonces

            </p>

            <p className={css.justify}>
            Les Détenteurs de place peuvent publier des Annonces sur la Plateforme. Pour créer une Annonce, le Détenteur de place devra communiquer plusieurs informations sur le Parking concerné, y compris notamment, sur sa localisation, ses dimensions (représentées par un pictogramme), ses caractéristiques, sa disponibilité et son prix en fonction du prix conseillé par ollo ainsi qu'une ou plusieurs photographie(s) du Parking.

Pour pouvoir figurer parmi les Annonces sur la Plateforme, l’adresse physique doit être valide et le test d'accès au Parking doit avoir été réussi. Les Annonces seront rendues publiques sur la Plateforme uniquement lorsque le city manager ollo aura validé cette dernière. Le Détenteur de place reconnaît et accepte que l’ordre des résultats de recherche peut dépendre de nombreux facteurs y compris, notamment, des besoins du Conducteur, de la localisation du Conducteur et des Evaluations. Les Conducteurs pourront réserver un Parking sur la Plateforme en fonction des informations stipulées dans l’Annonce. 
</p>


<p className={css.subTitle2}>
5.2 Période de Disponibilités

            </p>

            <p className={css.justify}>
            Les Détenteurs de Place déterminent les périodes et les types de Réservations pour lesquels ils veulent rendre leurs Parkings disponibles sur la Plateforme.

Les périodes de disponibilités des Parkings pour les Réservations Courte Durée, Unique et Récurrente sont modulables et précisées par les Détenteurs de Place. Les Détenteurs de Place peuvent rendre les Parkings disponibles en fonction de leur besoin.
</p>


<p className={css.subTitle2}>
5.3 Mise en relation

            </p>

            <p className={css.justify}>
            ollo fournit une Plateforme de mise en relation entre des Utilisateurs recherchant un Parking à louer et des Détenteurs de place souhaitant louer leur Parking. ollo est un intermédiaire qui n'est pas partie à l'opération de location qui est réalisée entre les Utilisateurs.

ollo fournit également à ses Utilisateurs un accès dématérialisé aux Parkings dont les Annonces sont mises en ligne sur sa Plateforme, via un système permettant d’encadrer la remise d’accès.

Tout Utilisateur accepte que tout recours ou responsabilité légale recherchée suite à des actes ou omissions d’autres Utilisateurs ou de tiers se limite à une réclamation à l’encontre des Utilisateurs ou autres tiers à l’origine du préjudice subi. Tout Utilisateur accepte de ne pas tenter de rechercher la responsabilité de ollo, de ses dirigeants ou de son personnel, ni de tenter un recours auprès de ollo, ses dirigeants ou de son personnel, pour de tels actes ou omissions.
</p>


<p className={css.subTitle}>
6.  Réservations

            </p>

            <p className={css.subTitle2}>
            6.1 Réservation avec remise en main propre

            </p>

            <p className={css.justify}>
            Lorsque les Utilisateurs procèdent à des Réservations avec remise physique des accès, le Détenteur de Place et le Conducteur ayant effectué la Réservation devront convenir entre eux des modalités de remise des accès physiques au Parking.

Les Utilisateurs reconnaissent que ollo n’intervient aucunement dans la remise des accès physiques entre les Utilisateurs. Si les Utilisateurs décident de se rencontrer physiquement, ils doivent prendre toutes les précautions nécessaires pour assurer leur sécurité.

ollo ne sera en aucun cas responsable de tout dommage, perte, vol ou incident de toute autre nature pouvant intervenir lors d’une rencontre physique entre les Utilisateurs.</p>


<p className={css.subTitle3}>
6.1.1  Réservation arrivée autonome

            </p>

            <p className={css.justify}>
            Lorsque les Utilisateurs procèdent à des Réservation avec arrivée autonome, le Détenteur de Place se doit de lister les informations nécessaires au bon déroulement de celle-ci.
</p>

<p className={css.subTitle3}>
6.1.1.1  Déroulé de la Réservation

            </p>


            <p className={css.justify}>
            Les Conducteurs sélectionnent une Annonce sur la Plateforme et effectuent une Réservation.

Le Détenteur de Place reçoit une notification sur l’Application et / ou reçoit un courrier électronique l’informant qu’un Conducteur a effectué une demande de Réservation. 

Le Conducteur reçoit alors un code d’activation (ci-après le « Code d’Activation ») qu’il devra utiliser pour procéder à la remise des Accès au Parking pour débuter la Réservation.</p>

<p className={css.subTitle3}>
6.1.1.2  Fin de la Réservation

            </p>


            <p className={css.justify}>
            En cas de difficultés relatives à la restitution des Accès à la fin du préavis ou de problèmes sur le Parking, le Détenteur de place dispose d’un délai de 48 heures pour signaler le problème au service client ollo.

Lorsqu’un Détenteur de Place signale un problème au terme d’une Réservation Récurrente, après vérification par ollo, le Conducteur peut se voir débiter une pénalité définie ci-après à l’article 8.7 afin de compenser la perte, le non restitution des Accès ou tout autre dommage au Parking.
</p>


<p className={css.subTitle3}>
6.1.1.3  Annulation de la Réservation

            </p>


            <p className={css.justify}>
            Le Conducteur peut annuler gratuitement une Réservation avant son début. Une fois la Réservation débutée, elle ne pourra pas être annulée et le Conducteur et le Détenteur de Place devront y mettre fin conformément à la procédure de fin de Réservation détaillée à l’article 6.1.1.2.
</p>

<p className={css.subTitle2}>
6.2 Modalités de Paiement

            </p>



            <p className={css.justify}>
            ​
La gestion du paiement des frais afférents aux Réservations est assurée par Stripe. Stripe assure en tant que prestataire de services de paiements, la gestion des comptes Stripe des Utilisateurs ollo ainsi que le mécanisme et les modalités de paiement lié aux Réservations effectuées sur la Plateforme par les Utilisateurs. . Ces paiements peuvent notamment concerner la Commission ollo, le tarif applicable à la Réservation et/ou les éventuelles Pénalités de retard. 

Les paiements réalisés au moyen d'une carte bancaire ne peuvent être inférieurs à la somme de un (1) euro. Si la somme due pour ce paiement était inférieure à un euro, le reliquat sera crédité sur votre compte.</p>


<p className={css.subTitle2}>
6.3 Assurances

            </p>

            <p className={css.justify}>
            Dans le cadre des Réservations conclues entre les Utilisateurs sur la Plateforme, ollo offre la possibilité de souscrire à une assurance. ollo n’assure en aucun cas les Réservations conclues sur la Plateforme, mais n'intervient que pour proposer le contrat souscrit auprès de la compagnie d'assurance Allianz.

Ces assurances permettent d’assurer certains risques pouvant survenir dans le cadre des Réservations. 
</p>

<p className={css.subTitle2}>
6.4 Evaluation

            </p>

            <p className={css.justify}>
         A l’issue de la Réservation d’un Parking, le Conducteur peut évaluer sur la Plateforme le déroulement de sa Réservation et son degré de satisfaction. Les Conducteurs attribuent un nombre d'étoiles compris entre 1 et 5.

ollo encourage les Utilisateurs à laisser une évaluation sur les Parkings qu'ils ont réservés. En revanche, les Utilisateurs ne sont pas autorisés à laisser une évaluation sur un Parking qu'ils n'ont pas réservé.

Seuls les Utilisateurs ayant effectué et terminé une Réservation dans un Parking pourront laisser une évaluation sur le Détenteur de Place.

L’Utilisateur reconnaît et accepte que ollo se réserve la possibilité de supprimer a posteriori toute évaluation dont elle jugerait le contenu contraire aux présentes CGU.
</p>



<p className={css.subTitle2}>
​

6.5 Limitation de responsabilité

            </p>


            <p className={css.justify}>
            Le Détenteur de place reconnaît et accepte être le seul responsable de toutes les Annonces qu’il souhaite publier. En conséquence, le Détenteur de place déclare et garantit que toute Annonce qu’il publie :
</p>


<ul>
              <li>
              - ne viole aucun accord conclu avec des tiers, tels que les accords de conseil syndical, les règlements de copropriété ou tout autre contrat conclu avec des tiers; et
               </li>
               <li>
               - sera conforme à toutes les lois applicables, réglementation pouvant s’appliquer à tout Parking, obligations fiscales et ne violent aucun droit de tiers.
               </li>
               
            </ul>

            <p className={css.justifyNoMargin}>
            ollo se réserve la possibilité de supprimer toute Annonce ou tout contenu contraire aux présentes CGU ainsi qu’aux lois et règlementations en vigueur.

Les Utilisateurs reconnaissent que ollo n’agit pas en qualité d’assureur ou d’agent pour leur compte. Les Utilisateurs reconnaissent que ollo exclut toute responsabilité concernant le respect par le Détenteur de place de tout accord ou obligation leur incombant, ainsi que des lois et réglementations applicables. ollo ne pourra pas non plus être tenu responsable de la non véracité des informations fournies dans les Annonces, ollo ne pouvant ni les modérer ni les vérifier a priori. Cependant, ollo s'engage à retirer ou faire corriger toute information incorrecte contenue dans les Annonces après leur signalement sur la Plateforme.
</p>



<p className={css.subTitle}>
7.  Disponibilité de la Plateforme et du Service

            </p>


            <p className={css.justify}>
            ollo s’efforcera, dans la mesure du possible, de maintenir la Plateforme accessible 7 jours sur 7 et 24 heures sur 24. Néanmoins, l’accès à la Plateforme pourra être temporairement suspendu, sans préavis, en raison d’opérations techniques de maintenance et de mises à jour ou en raison de pannes ou de contraintes liées au fonctionnement des réseaux ou encore en cas de force majeure.

Les Utilisateurs sont parfaitement informés que la Plateforme et le Service peuvent être suspendus à tout moment, sans préavis et sans qu’une quelconque indemnité ne soit due aux Utilisateurs, pour réaliser ces opérations de maintenance et de mise à jour. ollo n’est en aucun cas responsable de la non-réalisation d’une Réservation en cas d’indisponibilité de la Plateforme et/ou du Service, y compris lorsqu’une telle indisponibilité résulte d’une intervention de ollo sur Plateforme.

Dans l’hypothèse où un dysfonctionnement ou une anomalie entraverait le bon fonctionnement de la Plateforme ou du Service, ollo s’engage à procéder aux opérations nécessaires au rétablissement de la Plateforme ou du Service dans les meilleurs délais.

En outre, ollo se réserve le droit de modifier ou de suspendre, à sa seule discrétion, de manière temporaire ou permanente, tout ou partie de l’accès à la Plateforme ou de ses fonctionnalités, notamment, en cas d'utilisation frauduleuse ou abusive du système de Parrainage.
</p>


<p className={css.subTitle}>
​

8.  Conditions tarifaires

            </p>


            <p className={css.subTitle2}>
            8.1 Tarif applicable à la Réservation

            </p>

            <p className={css.justifyNoMargin}>
            Le tarif applicable à la Réservation se compose des éléments suivants:
</p>

<ul>
              <li>
              - Le Tarif Applicable à la Réservation;
               </li>
               <li>
               - La Durée Totale de la Réservation, y compris la durée des éventuels Dépassements et/ou de Prolongements;
               </li>
               <li>
               - L'éventuel Pénalité de retard;
               </li>
               <li>
               - La Commission ollo.
               </li>
            </ul>


            <p className={css.justify}>
            Le Tarif Applicable à la Réservation sera présenté au Conducteur sur la Plateforme ollo avant d'effectuer une Réservation.

Le Tarif Applicable à la Réservation peut varier en fonction de différents facteurs, tel que le moment de la Réservation (matin, après-midi, soir, nuit), le nombre de demandes de Réservation, la durée de la Réservation, le nombre de Parkings disponibles au moment de la Réservation etc.

ollo affichera toujours de façon transparente le Tarif Applicable à la Réservation.

Le Détenteur de Place recevra la totalité du montant de la Réservation effectuée sur son Parking à l'exception de la Commission ollo (définie à l'article 9.4) et éventuellement de la Pénalité de retard telle que définie à l'article 9.5 ci-dessous.

Pour les Réservations de plus de 5 jours, une réduction pourra être appliquée au Tarif Applicable et correspondra au Tarif Appliqué. Le Tarif Appliqué dépend la Durée Totale de la Réservation et est déterminé selon les critères non cumulables suivants:

Ce tarif dégressif n’impacte aucunement le montant des Pénalités de Retard définies à l’article 9.5.
              </p>


              <p className={css.subTitle2}>
              8.4 Commission ollo et frais de services
            </p>
            <p className={css.subTitle3}>
            8.4.1  Commission ollo
            </p>

            <p className={css.justify}>
            Pour l’ensemble des Réservations, la Commission ollo correspond à la part du montant de la Réservation que ollo perçoit au titre du Service ollo et notamment pour la mise en relation, la facilitation des Accès et pour la gestion de la Réservation et de la facturation.

La Commission ollo est déduite avant le versement du montant total de la Réservation au Détenteur de Place.
</p>

<p className={css.subTitle3}>
8.4.2  Frais de Services
            </p>
            <p className={css.justify}>
            Pour chaque Réservation, des frais de services seront appliqués et seront facturés au Conducteur effectuant la Réservation.

Les frais de services correspondent aux frais engagés par ollo pour la gestion de son service de mise en relation, de facilitation des Accès, de gestion des Réservations et de gestion de la facturation.
</p>




<p className={css.subTitle2}>
8.5 Prolongements 

            </p>


            <p className={css.justify}>
            Le Conducteur dispose de la possibilité de prolonger la Réservation Courte Durée ou Unique avant la fin de la Réservation (ci-après le « Prolongement »).

En sélectionnant l'option de Prolongement, le Conducteur est invité à sélectionner un nouvel horaire de fin de la Réservation. Le Prolongement ne sera possible que jusqu'à 10 minutes avant la fin de la période de disponibilité du Parking.

Le tarif applicable aux Prolongements est le Tarif Applicable.

Toute Réservation continuant après la fin de la période de disponibilité du Parking sera qualifié de Dépassement.
</p>  

<p className={css.subTitle2}>
8.6 Taxe d’habitation

            </p>


            <p className={css.justify}>
Dans certaines situations, les Utilisateurs sont susceptibles d’être redevables de la taxe d’habitation dans les conditions des articles 1407 et suivants du Code Général des Impôts. Le cas échéant, les Utilisateurs s’engagent à s’acquitter de leurs obligations fiscales en la matière.
</p>


<p className={css.subTitle}>
9.  Responsabilité

            </p>

            <p className={css.justify}>
            La Plateforme et le Service sont fournis en l’état. ollo ne saurait être tenu responsable pour un défaut de fonctionnement de la Plateforme ou du Service, tel que notamment un défaut de disponibilité.

L’Utilisateur étant regardé comme des consommateurs à l’égard de l’utilisation du Service, ollo est responsable sur le fondement des dispositions légales applicables de la bonne exécution de ses obligations au titre des CGU, sauf en cas de manquements imputables à l’Utilisateur, soit aux cas de Force Majeure (tel que définis à l’article 11).

L’Utilisateur est le seul et unique responsable de l’utilisation qu’il fait de la Plateforme ou du Service.

ollo décline toute responsabilité pour tout litige, plainte, réclamation, contestation, poursuite, etc. de quelque nature que ce soit liés directement ou indirectement à l’utilisation du Service à des fins illicites ou en contravention de l’une quelconque des obligations incombant à l’Utilisateur au titre des présentes CGU. L’Utilisateur déclare donc accepter pleinement et sans condition toutes les obligations légales découlant de l’utilisation du Service. En conséquence, la responsabilité de ollo ne pourra être recherchée à quelque titre que ce soit, notamment en cas de violation de lois ou règlements en vigueur applicables à l’Utilisateur.

L’utilisateur reconnait être seul responsable de toute communication et /ou interaction avec d’autres utilisateurs de la Plateforme et/ou du Service y compris, notamment tout Conducteur ou Détenteur de place. L’utilisateur comprend et accepte que ollo n’essaiera pas de vérifier les déclarations des Utilisateurs du Service. ollo ne fait aucune déclaration ou garantie concernant le comportement des Utilisateurs de la Plateforme ou du Service.

L’Utilisateur accepte de prendre des précautions raisonnables lorsqu’il communique entre en contact avec d’autres Utilisateurs. Plus spécifiquement dans l’éventualité ou des Utilisateurs décideraient de se rencontrer hors ligne ou en personne, que cette rencontre soit ou non organisée sur la Plateforme. ollo exclut expressément toute responsabilité à cet égard.
</p>




<p className={css.subTitle}>
10.  Force majeure

            </p>


            <p className={css.justify}>
            ollo ne sera pas tenu responsable de tout retard ou inexécution, lorsque la cause du retard ou de l'inexécution serait due à la survenance d'un cas de force majeure tels que, outre ceux habituellement reconnus par la jurisprudence, le blocage des télécommunications, le blocage d’Internet, la panne du matériel diffusant le service, l’incendie, les dégâts des eaux, le blocage des moyens de transport ou d’approvisionnement, la grève totale ou partielle, ou tout autre événement au caractère imprévisible, irrésistible et extérieur.

Chaque partie devra informer l'autre dans les meilleurs délais en cas de survenance d'un événement de force majeure l'empêchant d'exécuter tout ou parties de ses obligations

Le cas de force majeure suspend les obligations nées des présentes conditions pendant toute la durée de son existence. Cependant si le cas de force majeure avait une durée d'existence supérieure à un (1) mois consécutif, il ouvrirait droit à la résiliation de plein droit des présentes conditions par l'une ou l'autre des parties quinze (15) jours après notification par tout moyen de cette décision.
</p>

<p className={css.subTitle}>
11.  Politique de protection des données personnelles

            </p>

            <p className={css.justify}>
            La « Politique de Protection des Données » de même que les dispositions figurant aux « Mentions Légales », font partie intégrante des présentes conditions. Dès lors qu'il accepte les présentes conditions, l’Utilisateur déclare accepter également les termes de ces dernières.

Dans le cadre de l’utilisation du Service et de la Plateforme, ollo est amenée à collecter et traiter certaines données personnelles de ses Utilisateurs. En utilisant le Site ou la Plateforme, les Utilisateurs reconnaissent et acceptent le traitement de leurs données personnelles par ollo conformément à la réglementation en vigueur et à la Politique de Confidentialité des Données

Le Service ollo utilise des cookies pour améliorer l'expérience utilisateur, faciliter la navigation, et mesurer la fréquentation de nos services. Si vous souhaitez vous opposer à l'utilisation des cookies, certaines rubriques du site risquent de ne pas fonctionner.
</p>


<p className={css.subTitle}>
12.  Propriété Intellectuelle
            </p>


            <p className={css.subTitle2}>
            12.1  Droits de propriété Intellectuelle

            </p>


 <p className={css.justify}>
 ollo est titulaire de l’ensemble des droits de propriété intellectuelle afférents aux éléments textuels, visuels, sonores, vidéographiques, logiciels et bases de données ou de toute autre nature composant la Plateforme, notamment la marque ollo, à l’exception des informations renseignées par les Utilisateurs. ollo est l’unique propriétaire des droits de propriété intellectuelle sur les technologies utilisées et notamment sur la Télécommande ollo. La Plateforme constitue une œuvre sur laquelle ollo est le seul titulaire des droits de propriété intellectuelle.

L’Utilisateur s’engage à ne pas porter atteinte aux droits de propriété intellectuelle de ollo. Aucune fonctionnalité de la Plateforme, ne peut être utilisée par l’Utilisateur avec l’objet ou avec l’effet de porter atteinte aux droits de propriété intellectuelle attachés à la Plateforme et aux éléments qui le composent. L’utilisateur s’engage expressément à ne pas reconstituer ou d’aider un tiers à reconstituer, à partir de la Plateforme ou de n’importe lequel de ses éléments un service visant à offrir directement ou indirectement, à titre gratuit ou onéreux, un service identique ou similaire et tout ou partie du Service. De même, il est formellement interdit de procéder à de l’ingénierie inversée (« retro-engineering ») pour toute autre fin que celle de l’interopérabilité du Service, de la Plateforme ou de n’importe lequel de ses éléments, avec une application tierce.
              </p>

              <p className={css.subTitle2}>
              12.2  Licence

            </p>

            <p className={css.justify}>
            Sous réserve de votre respect des présentes Conditions, ollo concède aux Utilisateurs une licence limitée, non transmissible, non cessible et non exclusive afin de pouvoir télécharger et installer une copie de l’Application sur chaque appareil mobile ou ordinateur possédé ou contrôlé. De plus, les Utilisateurs n’utiliseront que les applications provenant de l’App Store (définies ci-dessous) (qu’avec un produit de marque Apple fonctionnant sous iOS (système d’exploitation exclusif d’Apple) ou du Google Play Store© (magasin d'applications pour le système d'exploitation Android) et de la manière autorisée par les « Conditions d’Utilisation » stipulées dans les Conditions de Service de l’App Store d’Apple©. ollo se réserve tous les droits sur l’Application qui ne vous sont pas expressément concédés dans les présentes CGU.
              </p>


              <p className={css.subTitle}>
              13. Loi Applicable
            </p>



            <p className={css.justify}>
Les présentes CGU sont soumises au droit français.

En cas de litige notamment lié à l’interprétation ou l’exécution des présentes CGU, les parties s’engagent à rechercher une solution amiable, en particulier en contactant le Service Client.
</p>


          </div> 
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
  
    </Page>
  );
};

const { bool } = PropTypes;

CGUPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const CGUPage = compose(
  connect(mapStateToProps),
  injectIntl
)(CGUPageComponent);

export default CGUPage;
